<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="95px"
  >
    <el-form-item
      label="公众号名称"
      prop="name"
    >
      <el-input
        placeholder="公众号名称"
        v-model="form.name"
      ></el-input>
    </el-form-item>
    <div class="padding text-gray item-desc">测试号可选择服务号，不同类型账号、是否认证可使用功能权限不同</div>
    <el-row
      :gutter="10"
    >
      <el-col
        :lg="20"
        :md="12"
        :sm="14"
        :xs="14"
        class="el-col-el"
      >
        <el-form-item
          prop="type"
          label="公众号类型"
        >
          <el-select
            style="width: 100%"
            v-model="form.type"
            placeholder="公众号类型"
          >
            <el-option
              v-for="(item,index) in typeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="10"
        :xs="10"
        class="el-col-el"
      >
        <el-form-item
          label-width="70px"
          prop="verified"
          label="是否认证"
        >
          <el-switch
            v-model="form.verified"
            placeholder="是否认证"
          ></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item
      label="绑定域名"
      prop="articleDomain"
    >
      <el-input
        v-model="form.articleDomain"
        placeholder="请输入绑定域名"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="appid"
      prop="appid"
    >
      <el-input
        v-model="form.appid"
        placeholder="appid"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="appsecret"
      prop="secret"
    >
      <el-input
        v-model="form.secret"
        placeholder="appsecret"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="token"
      prop="token"
    >
      <el-input
        v-model="form.token"
        placeholder="token"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="aesKey"
      prop="aesKey"
    >
      <el-input
        v-model="form.aesKey"
        placeholder="aesKey"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>

let origin = {
  name: '',
  type: 2,
  verified: '',
  articleDomain: '',
  appid: '',

  aesKey: '',
  secret: '',
  token: '',
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "accountForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {
          userId: ''
        };
      }
    }
  },
  data() {
    return {
      typeList: [
        {label: '订阅号',value: 1},
        {label: '服务号',value: 2},
      ],
      permissionList: [],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        name: [
          { required:true, message: '公众号名称不能为空', trigger: 'blur' },
        ],
        articleDomain: [
          // { required:true, message: '文章域名不能为空', trigger: 'blur' },
        ],
        appid: [
          { required:true, message: 'appid不能为空', trigger: 'blur' },
        ],
        secret: [
          {required: true, message: 'appsecret不能为空', trigger: 'blur'}
        ]
      },
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.appid){
          this.assigen(newValue);
        }
      },
      deep: true,
      immediate: true,
    }
  },
  mixins: [formLabalPosition],
  created(){
  },
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(data){
      this.form.name = data.name;
      this.form.type = data.type;
      this.form.verified = data.verified;
      this.form.articleDomain = data.articleDomain;
      this.form.appid = data.appid;
      this.form.secret =data.secret;
      this.form.token = data.token;
      this.form.aesKey = data.aesKey;
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .item-desc {
    padding-left: 100px;
  }
}
.item-desc {
  margin-bottom: 10px;
}
</style>
